import { GlobalSettingType } from "./type";

export const setGlobalSetting = (payload: any) => {
  return { type: GlobalSettingType.SET_GLOBAL_SETTING, payload };
};
